import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectDocumentUploadComplete } from '@store/selectors/agreement/agreement.selectors';
import { AgreementActions } from '@store/actions/agreement/agreement.actions';
import { DocumentUploadComponent } from "../../document-upload/document-upload.component";

@Component({
  selector: 'app-document-upload-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    DocumentUploadComponent
],
  templateUrl: './document-upload-modal.component.html',
  styleUrl: './document-upload-modal.component.css'
})
export class DocumentUploadModalComponent {
  uploadComplete$: Observable<boolean>;

  constructor(
    private dialogRef: MatDialogRef<DocumentUploadModalComponent>,
    private store: Store,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.uploadComplete$ = this.store.select(selectDocumentUploadComplete);
    
    this.uploadComplete$.subscribe(complete => {
      if (complete) {
        setTimeout(() => {
          this.close(true);
        }, 2000);
      }
    });
  }

  close(result?: boolean): void {
    this.store.dispatch(AgreementActions.clearDocumentUploadState());
    this.dialogRef.close(result);
  }
}